import { Box, Flex, Text } from '@chakra-ui/react';
import type { CartRecommendationCartProduct } from '@diamond/shared/types';
import { CheckCircle } from '@mui/icons-material';

import { CartRecommendationModule } from '../../carts/cart-recommendation';
import { ModalNotification } from '../modal-notification';

interface SuccessContentProps {
  isCartRecommendationEnabled: boolean;
  productTitle?: string;
  addedItemCode?: number;
  cartSnapshot: CartRecommendationCartProduct[];
  onClose: () => void;
  isMobile: boolean;
  /** Page the add-to-cart popup was opened from, forwarded to FBT tracking. */
  page?: string;
}

export function SuccessContent({
  isCartRecommendationEnabled,
  productTitle,
  addedItemCode,
  cartSnapshot,
  onClose,
  isMobile,
  page,
}: SuccessContentProps) {
  if (!isCartRecommendationEnabled) {
    return (
      <ModalNotification
        isOpen={true}
        onClose={onClose}
        title={'Berhasil ditambahkan ke dalam keranjang!'}
        primaryLabel={'Lanjutkan Belanja'}
        onPrimary={onClose}
        secondaryLabel={'Lihat Keranjang'}
        onSecondary={() => (window.location.href = '/cart')}
        size={isMobile ? 'xs' : 'md'}
      />
    );
  }

  return (
    <Box pt={2}>
      <Flex align="center" gap={2} mb={4}>
        <Box
          as={CheckCircle}
          color="#34C759"
          sx={{ fontSize: '24px' }}
          flexShrink={0}
        />
        <Text fontSize="16px" fontWeight="semibold" color="#373F41">
          <Text as="span" color="#0000A3" fontWeight="medium">
            {productTitle}
          </Text>{' '}
          Berhasil Ditambah ke Keranjang!
        </Text>
      </Flex>
      <CartRecommendationModule
        displayContext="add_to_cart_success_popup"
        selectedProductItemCodes={addedItemCode ? [addedItemCode] : []}
        cartItems={cartSnapshot}
        maxItems={4}
        originPageName={page}
        addedItemName={productTitle}
      />
    </Box>
  );
}
